import { Button } from "common/components/ui/Button";

import type { ComponentProps } from "react";

export default function StepperNextButton(
  props: ComponentProps<typeof Button>,
) {
  return (
    <Button {...props} size="md">
      Next
    </Button>
  );
}
